// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dCUlW","buttonsWrapper":"styles_buttonsWrapper__QUjrq"};